export const RARITY_FULL = {
  C: "Comune",
  UC: "Non Comune",
  R: "Rara",
  SR: "Super Rara",
  SEC: "Segreta",
  L: "Leader",
  P: "Promo",
};

export function rarityMeta(r) {
  const map = {
    C: { label: "C", cls: "bg-slate-100 text-slate-600 border-slate-200", high: false },
    UC: { label: "UC", cls: "bg-emerald-100 text-emerald-700 border-emerald-200", high: false },
    R: { label: "R", cls: "bg-sky-100 text-sky-700 border-sky-200", high: false },
    SR: { label: "SR", cls: "bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200", high: true },
    SEC: { label: "SEC", cls: "bg-amber-100 text-amber-700 border-amber-200", high: true },
    L: { label: "L", cls: "bg-indigo-100 text-indigo-700 border-indigo-200", high: true },
    P: { label: "P", cls: "bg-pink-100 text-pink-700 border-pink-200", high: false },
  };
  return map[r] || { label: r || "?", cls: "bg-slate-100 text-slate-600 border-slate-200", high: false };
}

export const COLOR_HEX = {
  Red: "#ef4444",
  Green: "#22c55e",
  Blue: "#3b82f6",
  Purple: "#a855f7",
  Black: "#475569",
  Yellow: "#eab308",
};

export function cardGradient(colors = []) {
  const cs = (colors || []).map((c) => COLOR_HEX[c]).filter(Boolean);
  if (cs.length === 0) return "linear-gradient(140deg,#64748b,#334155)";
  if (cs.length === 1) return `linear-gradient(140deg,${cs[0]},#1e293b)`;
  return `linear-gradient(140deg,${cs.join(",")})`;
}

export function isSpecial(card) {
  if (!card) return false;
  return rarityMeta(card.rarity).high || card.is_base === false;
}

// Verified high-rarity tier for celebration effects (based on canonical rarity only).
export function rarityTier(card) {
  const r = card?.rarity;
  if (r === "L" || r === "SEC") return "legendary";
  if (r === "SR") return "epic";
  return null;
}

export const TIER_LABEL = { legendary: "RARITÀ LEGGENDARIA!", epic: "SUPER RARA!" };
export const TIER_COLORS = {
  legendary: ["#fde047", "#fbbf24", "#f59e0b", "#fff7cc", "#fef08a"],
  epic: ["#c084fc", "#f0abfc", "#f472b6", "#a78bfa", "#38bdf8"],
};

export function fmtCountdown(ms) {
  if (ms <= 0) return "00:00";
  const t = Math.floor(ms / 1000);
  const m = Math.floor(t / 60);
  const s = t % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");
  return `${mm}:${ss}`;
}

export const FAMILY_LABEL = {
  OP: "Booster",
  EB: "Extra Booster",
  PRB: "Premium",
  ST: "Starter Deck",
  PROMO: "Promo",
  OTHER: "Altri prodotti",
};
